import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export interface FeedbackConfig {
    appId: number;
    fluidAppId: number;
    fluidContentPage: string;
    autopopulateEmail: boolean;
    environment: number;
    intlUrl: string;
    scriptUrl: string;
    screenshotEnabled: boolean;
    stylesUrl: string;
}

@Injectable({
    providedIn: 'root'
})
export class FeedbackConfigService {
    public readonly config: FeedbackConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<FeedbackConfig>('feedbackConfig');
    }
}
